import React from 'react';

import type { INewPatientsData } from 'infrastructure/interfaces/';

interface IProps {
  data: INewPatientsData;
}

const PatientNameColumn: React.FC<IProps> = ({ data }) => {
  return (
    <div>
      {data.firstName} {data.lastName}
    </div>
  );
};

export default PatientNameColumn;
